import { isEmpty, isNil } from 'ramda';
import type { ValueElementIdAPI, ValueElementIdReferenceAPI } from '../types/value';

export const isString = (value: unknown): value is string => {
    return typeof value === 'string';
};

export const isArray = (value: unknown): value is [] => {
    return Array.isArray(value);
};

export const isObject = (value: unknown): value is Record<string, unknown> => {
    return value !== null && typeof value === 'object' && !Array.isArray(value);
};

export const isNullOrWhitespace = (value: unknown): value is null | undefined | string => {
    return (
        value === null ||
        typeof value === 'undefined' ||
        (typeof value === 'string' && value.trim().length === 0)
    );
};

export const isNullOrUndefined = (value: unknown): value is null | undefined => {
    return value === null || typeof value === 'undefined';
};

const EMPTY_GUID = '00000000-0000-0000-0000-000000000000';

export const isEmptyGuid = (value: string | null | undefined): boolean =>
    value === null || value === undefined || value === EMPTY_GUID;

export const isNullOrEmpty = (
    item: unknown,
): item is null | undefined | [] | Record<string, never> | '' => isNil(item) || isEmpty(item);

export const isValueReference = (
    value: unknown,
): value is ValueElementIdAPI | ValueElementIdReferenceAPI =>
    isObject(value) && Object.hasOwn(value, 'typeElementPropertyId');

export const isFullValueReference = (value: unknown): value is ValueElementIdReferenceAPI =>
    isValueReference(value) && Object.hasOwn(value, 'developerName');
